<ng-content></ng-content>

@if (isVersionVisible) {
<div class="version-info">
  Copyright &copy; 2021 Auvious. Version {{ version }}
</div>
} @if (!isMobile) {
<div appThemableLogo class="logo-text"></div>
}
